(function () {
  var container = document.querySelector('.article--content');
  if (!container) return;

  var headings = container.querySelectorAll('h2, h3, h4');
  if (!headings.length) {
    var tocNav = document.getElementById('article-toc');
    if (tocNav) tocNav.style.display = 'none';
    return;
  }

  var tocList = document.getElementById('article-toc-list');
  var tocToggle = document.querySelector('.article-toc__toggle');
  var tocIcon = document.querySelector('.article-toc__icon');
  var tocNav = document.getElementById('article-toc');

  headings.forEach(function (heading, i) {
    if (!heading.id) {
      heading.id = heading.textContent
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '') + '-' + i;
    }

    var li = document.createElement('li');
    li.className = 'toc-' + heading.tagName.toLowerCase();

    var a = document.createElement('a');
    a.href = '#' + heading.id;
    a.textContent = heading.textContent;

    li.appendChild(a);
    tocList.appendChild(li);
  });

  tocToggle.addEventListener('click', function () {
    var expanded = tocToggle.getAttribute('aria-expanded') === 'true';
    tocToggle.setAttribute('aria-expanded', !expanded);
    tocList.classList.toggle('article-toc__list--hidden');
    tocIcon.textContent = expanded ? '+' : '\u2212';
  });

  var links = tocList.querySelectorAll('a');
  function onScroll() {
    var scrollY = window.scrollY + 100;
    var current = null;
    headings.forEach(function (h) {
      if (h.offsetTop <= scrollY) current = h.id;
    });
    links.forEach(function (link) {
      link.classList.toggle('active', link.getAttribute('href') === '#' + current);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
